export const questionConfig = [
  {
    name: 'hasInfo:switch',
    default: false,
    category: 'Info',
  },
  {
    name: 'infoText:html',
    default: 'Put your info text',
    isLocalizable: true,
    category: 'Info',
    dependsOn: 'hasInfo',
    visibleIf: (obj: any) => obj.hasInfo === true,
  },
  {
    name: 'infoTitle',
    default: 'More information',
    isLocalizable: true,
    category: 'Info',
    dependsOn: 'hasInfo',
    visibleIf: (obj: any) => obj.hasInfo === true,
  },
  {
    name: 'hasTooltip:switch',
    category: 'Tooltip',
    default: false,
  },
  {
    name: 'tooltip:html',
    default: 'Put your tooltip here',
    category: 'Tooltip',
    isLocalizable: true,
    dependsOn: 'hasTooltip',
    visibleIf: (obj: any) => obj.hasTooltip === true,
  },
  {
    name: 'sentimentLabels',
    type: 'sentimentEditor',
    isRequired: false,
    category: 'Sentiment labels editor',
    visibleIndex: 1,

    visibleIf: function (obj: any) {
      if (!obj) return false;
      return (
        obj.getType() === 'text' ||
        obj.getType() === 'comment' ||
        obj.getType() === 'multipletext' ||
        obj.getType() === 'checkbox' ||
        obj.getType() === 'radiogroup'
      );
    },
  },
  {
    name: 'sentiment',
    type: 'sentiment',
    isRequired: false,
    category: 'Sentiment',
    visibleIndex: 1,
    isSerializable: true,
    visibleIf: function (obj: any) {
      if (!obj) return false;
      return obj.getType() === 'text' || obj.getType() === 'comment';
    },
  },
];
